module.exports = __webpack_public_path__ + "static/media/pp-icon-person.19390888.png";